import React from "react";
import { useNotification } from "../../../context/NotificationContext";
import Notification from "./Notification";
import "./Notification.css";

const NotificationContainer = () => {
  const { notifications, removeNotification } = useNotification();

  // اگه نوتیفیکیشنی نیست، چیزی رندر نکن
  if (notifications.length === 0) return null;

  // گروه‌بندی بر اساس position
  const grouped = notifications.reduce((acc, notification) => {
    const pos = notification.position || "top-center";
    if (!acc[pos]) acc[pos] = [];
    acc[pos].push(notification);
    return acc;
  }, {});

  return (
    <>
      {Object.entries(grouped).map(([position, notifs]) => (
        <div key={position} className={`notification-container ${position}`}>
          {notifs.map((notification, index) => (
            <Notification
              key={notification.id}
              message={notification.message}
              type={notification.type}
              duration={notification.duration}
              actions={notification.actions}
              style={{
                marginBottom: index < notifs.length - 1 ? "10px" : "0",
                zIndex: 999999 - index, // آخرین پیام بالاتر باشه
              }}
              onClose={() => removeNotification(notification.id)}
            />
          ))}
        </div>
      ))}
    </>
  );
};

export default NotificationContainer;
